/* eslint-disable class-methods-use-this */
import { BaseModule } from './BaseModule';

export class DisplayLink extends BaseModule {
  onCreate = () => {
    // Create the container to hold the link display
    this.display = document.createElement('div');

    // Apply styles
    Object.assign(this.display.style, this.options.displayStyles);

    // Attach it
    const url = this.getCurrentUrl();

    if (url) {
      this.overlay.appendChild(this.display);
    }
  };

  onDestroy = () => {};

  onUpdate = () => {
    const url = this.getCurrentUrl();

    if (!this.display || !this.img || !url) {
      Object.assign(this.display.style, {
        display: 'none',
      });

      return;
    }

    this.display.innerHTML = url;
    Object.assign(this.display.style, {
      left: '4px',
      bottom: '4px',
      right: 'auto',
      display: 'block',
      maxWidth: '50%',
    });
  };

  getCurrentUrl = () =>
    this.img?.parentNode?.tagName === 'A' ? this.img?.parentNode?.href : null;
}
